import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/plusIcon.svg'
import _imports_1 from '@/assets/editIcon.svg'
import _imports_2 from '@/assets/correctIcon.svg'
import _imports_3 from '@/assets/cancel.svg'
import _imports_4 from '@/assets/deleteIcon.svg'


const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Organisation User Activity", -1)
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "accordion-body bg-white"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "border-t-2" }, null, -1)
const _hoisted_7 = { class: "p-4" }
const _hoisted_8 = { class: "font-opensans" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", null, "Users", -1)
const _hoisted_10 = { class: "flex justify-center items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-5 w-5"
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["onChange", "onUpdate:modelValue", "disabled"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", {
  value: "0",
  class: "disabled"
}, "please select type", -1)
const _hoisted_15 = ["value"]
const _hoisted_16 = ["onUpdate:modelValue", "disabled"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "please select type", -1)
const _hoisted_18 = ["value"]
const _hoisted_19 = ["onUpdate:modelValue", "disabled"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", {
  value: "0",
  disabled: ""
}, "please select type", -1)
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "child-action-col" }
const _hoisted_23 = { class: "flex flex-row align-center" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "h-5 w-5"
}, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "h-5 w-5"
}, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "h-5 w-5 ml-2"
}, null, -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "h-5 w-5 ml-2"
}, null, -1)
const _hoisted_35 = [
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.organisations, (organisation) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["text-black no-underline mt-0.5 min-h-30 cursor-pointer", { accordion: organisation.isToggle }]),
          key: organisation._id
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["flex bg-white py-2.5 px-2.5 text-lg rounded cursor-pointer", { 'accordion-head': !organisation.isToggle }])
          }, [
            _createElementVNode("div", {
              class: "title font-opensans font-semibold text-lg w-full flex cursor-pointer",
              onClick: ($event: any) => (organisation.isToggle = !organisation.isToggle)
            }, _toDisplayString(organisation.organizationName), 9, _hoisted_4)
          ], 2),
          (organisation.isToggle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("table", _hoisted_8, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_9,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apps, (app) => {
                          return (_openBlock(), _createElementBlock("th", {
                            class: "header cursor-pointer",
                            key: app.id
                          }, [
                            _createElementVNode("div", null, _toDisplayString(app.appName), 1)
                          ]))
                        }), 128)),
                        _createElementVNode("th", _hoisted_10, [
                          _createElementVNode("div", {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addUser()))
                          }, _hoisted_12)
                        ])
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersArray, (user, userIndex) => {
                        return (_openBlock(), _createElementBlock("tr", { key: user }, [
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("select", {
                              class: "inputboxstyling",
                              onChange: ($event: any) => (_ctx.selectUser($event, user)),
                              "onUpdate:modelValue": ($event: any) => ((user.selecteduserName) = $event),
                              disabled: user.editOption
                            }, [
                              _hoisted_14,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userData, (singleuser) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: singleuser,
                                  value: singleuser.name
                                }, _toDisplayString(singleuser.name), 9, _hoisted_15))
                              }), 128))
                            ], 40, _hoisted_13), [
                              [_vModelSelect, user.selecteduserName]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("select", {
                              class: "inputboxstyling",
                              "onUpdate:modelValue": ($event: any) => ((user.selectMonitor) = $event),
                              disabled: user.editOption
                            }, [
                              _hoisted_17,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles.filter((role) => {
												return role.moduleId == 10001;
											}), (role) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: role.roleId,
                                  key: role.roleId
                                }, _toDisplayString(role.roleName), 9, _hoisted_18))
                              }), 128))
                            ], 8, _hoisted_16), [
                              [_vModelSelect, user.selectMonitor]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("select", {
                              class: "inputboxstyling",
                              "onUpdate:modelValue": ($event: any) => ((user.selectTraining) = $event),
                              disabled: user.editOption
                            }, [
                              _hoisted_20,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles.filter((role) => {
												return role.moduleId == 10002;
											}), (role) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: role.roleId,
                                  key: role.roleId
                                }, _toDisplayString(role.roleName), 9, _hoisted_21))
                              }), 128))
                            ], 8, _hoisted_19), [
                              [_vModelSelect, user.selectTraining]
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              (!user.showSave)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "px-1 py-0",
                                    onClick: ($event: any) => (_ctx.editUser(userIndex))
                                  }, _hoisted_26, 8, _hoisted_24))
                                : _createCommentVNode("", true),
                              (user.showSave)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    onClick: ($event: any) => (_ctx.onSubmit(user, organisation, user.selecteduserName,userIndex))
                                  }, _hoisted_29, 8, _hoisted_27))
                                : _createCommentVNode("", true),
                              (user.showSave)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    onClick: ($event: any) => (_ctx.clearAllFlags(userIndex))
                                  }, _hoisted_32, 8, _hoisted_30))
                                : _createCommentVNode("", true),
                              (!user.showSave)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 3,
                                    onClick: ($event: any) => (_ctx.clearUser(userIndex))
                                  }, _hoisted_35, 8, _hoisted_33))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ]),
    (_ctx.isLoader)
      ? (_openBlock(), _createBlock(_component_spinner, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}